module.exports = __webpack_public_path__ + "images/storefront-black-e915f8d3.svg";